module.exports = __webpack_public_path__ + "img/L1.2be5335c.jpg";